module.exports = __webpack_public_path__ + "static/media/correct.e232c57d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/stores/audio/correct.mp3
// module id = 629
// module chunks = 0